export const setComma = (value: number | string | null) => {
  if (value === undefined || value === null) {
    return '-'
  }
  if (typeof value === 'number') {
    value = value.toString()
  }
  if (Number.isNaN(parseFloat(value)) || !parseFloat(value)) {
    return '-'
  }
  const [ integer, decimal ] = value.split('.')
  const integerWithComma = parseInt(integer).toLocaleString('ko-KR')
  if (parseInt(decimal)) {
    return integerWithComma.concat('.', decimal)
  }
  return integerWithComma
}

export const setPositiveSign = (value: number | string) => {
  const replacedValue = parseFloat(String(value))
  if (Math.sign(Number(replacedValue)) > 0) {
    return `+${value}`
  }
  return value
}

export const setFixed = (value: number | string, fixed: number) => {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return '-'
  }
  if (typeof value === 'number') {
    value = value.toString()
  }
  const [ integer, decimal ] = value.split('.')
  if (!decimal || decimal.length < fixed) {
    return `${integer}.${(decimal ?? '').padEnd(fixed, '0')}`
  }
  return `${integer}.${decimal.slice(0, fixed)}`
}